import { DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers';

import React, { useState } from 'react';
import { IDateTimePicker } from './interfaces';

export const DateTimePicker: React.FC<IDateTimePicker> = ({
  label,
  selectedDateTime,
  error,
  errorMessage,
  helperMessage,
  onChange,
  disabled,
  minDateTime,
  disableFuture,
  disablePast,
}): JSX.Element => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <MuiDateTimePicker
      label={label}
      open={showDialog}
      onClose={() => setShowDialog(false)}
      value={selectedDateTime}
      onChange={(date) => onChange(date)}
      disabled={disabled}
      ampm={false}
      minDateTime={minDateTime}
      disableFuture={disableFuture}
      disablePast={disablePast}
      slotProps={{
        textField: {
          size: 'small',
          InputProps: {
            readOnly: true,
            onClick: () => setShowDialog(true),
          },
          error: error,
          helperText: error ? errorMessage : helperMessage,
          sx: {
            fontSize: '0.9rem',
            input: {
              fontSize: '0.9rem',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '16px',
            },
          },
        },
      }}
    />
  );
};
